import { UserProfile } from '__generated__/GQL';
import { ApplicantType } from 'features/Onboarding/types';

import { VerificationStatus } from '../../Verification/lib/steps/types';

type GetComplianceStatusProps = {
  userProfile: Pick<UserProfile, 'isComplianceFilled' | 'isEligibleToOnboard'>;
  applicantType: ApplicantType;
};

const getComplianceStatus = ({
  applicantType,
  userProfile,
}: GetComplianceStatusProps) => {
  // Mandatees don't have to answer compliance question
  // See https://www.notion.so/shinetools/Can-we-drop-the-personal-patrimony-income-estate-size-FATCA-and-CRS-questions-for-the-mandatee-d7a3d5bcb92546f79e6c291127353fbd
  if (applicantType === ApplicantType.Mandatee) {
    return VerificationStatus.Irrelevant;
  }

  if (userProfile.isComplianceFilled && userProfile.isEligibleToOnboard) {
    return VerificationStatus.Completed;
  }

  return VerificationStatus.ToDo;
};

export default getComplianceStatus;
